export default __webpack_public_path__ + "static/media/loyalty.c7f2122c.svg";